import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiInstance } from "./axiosApi";
import authHeader from "./authHeader";

export const getAllQa = createAsyncThunk(
    "student/allQa",
    async ({ page, limit,contestFilter,qaId }, { rejectWithValue }) => {
      try {
        let url = `/qa/all?page=${page}&limit=${limit}`;
        if (contestFilter) {
          url += `&contestFilter=${contestFilter}`;
        }
        if (qaId) {
          url += `&qaFilter=${qaId}`;
        }
        const response = await apiInstance.get(url, {
          headers: authHeader(),
        });
        return response;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  );
  const initialState={}
const qaSlice = createSlice({
  name: "qaSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllQa.fulfilled, (state, action) => {
      state.qaData = action.payload.data;
    });
  },
});
export default qaSlice.reducer;